import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';
import { useCurrentUser } from './useCurrentUser';

export type Profile = NonNullable<FunctionReturnType<typeof api.profiles.byHandle>>;

/** A public profile by handle: undefined while loading, null when nobody owns it. */
export function useProfile(handle: string | undefined) {
  const { user } = useCurrentUser();
  return useQuery(api.profiles.byHandle, user && handle ? { handle } : 'skip');
}
